import { render } from "./AnalyticsRetention.vue?vue&type=template&id=134117f6"
import script from "./AnalyticsRetention.vue?vue&type=script&lang=js"
export * from "./AnalyticsRetention.vue?vue&type=script&lang=js"

import "./AnalyticsRetention.vue?vue&type=style&index=0&id=134117f6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__